import { useContext } from 'react';
import { createContext } from 'react';

import { SocialNetworkProps } from '../@types/SocialNetworkProps';

export const SocialNetworkContext = createContext<SocialNetworkProps>({} as SocialNetworkProps);

SocialNetworkContext.displayName = 'SocialNetwork';

const SocialNetworkProvider = (props: SocialNetworkProps) => (
	<SocialNetworkContext.Provider value={props}>{props.children}</SocialNetworkContext.Provider>
);

export const useSocialNetwork = () => {
	const context = useContext(SocialNetworkContext);

	return context;
};

export default SocialNetworkProvider;
